import { render } from "./OrderLog.vue?vue&type=template&id=d88f7d60&scoped=true"
import script from "./OrderLog.vue?vue&type=script&lang=js"
export * from "./OrderLog.vue?vue&type=script&lang=js"

import "./OrderLog.vue?vue&type=style&index=0&id=d88f7d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88f7d60"]])

export default __exports__